import React from "react";
import { imageURl } from "../../libs/env";
export const SpeakFooter = () => {
  return (
      <div className="col-12 d-flex justify-content-center align-items-center pt-1 pb-2 border-top">
        <p className="powered-text me-2">Powered by</p>
        <img src={`${imageURl}/g_black_logo.png`} height={"30px"} alt="logo" />{" "}
      </div>
  );
};

export default SpeakFooter;
